import { AppstoreOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Form, Modal, notification, Popconfirm, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import parkService from '../../../services/config/park.service';
import AddFreeAddOnRuleModal from './add_free_add_on_rule_modal';
import EditFreeAddOnRuleModal from './edit_free_add_on_rule_modal';

const FreeAddOnLayout = ({ park, }) => {
    const [save_form] = Form.useForm();
    const [edit_form] = Form.useForm();
    const [state, setState] = useState({
        loading : false,
        free_add_on_rules : [],

        create_modal : false,
        edit_modal : null,

        save_loading : false,
        update_loading : false,

        refresh : 0,
        modal : 0,
    });

    const saveFreeAddOnRule = async () => {
        setState(state => ({...state, save_loading : true, }));
        const { name, park_applicable_ticket_type_id, is_adjustable, free_add_on_quantity, add_on_setup_id, min_required_ticket_quantity, max_required_ticket_quantity, free_add_on_rule_requires = [], } = (save_form?.getFieldsValue());
        const saveFreeAddOnRuleResponse = await parkService?.saveFreeAddOnRule({
            name, park_applicable_ticket_type_id, is_adjustable, free_add_on_quantity, add_on_setup_id, min_required_ticket_quantity, max_required_ticket_quantity, free_add_on_rule_requires,
        })
        
        notification?.success({
            message : 'Added Add On Purchase Condition',
        })

        setState(state => ({...state, save_loading : false, refresh : (state?.refresh + 1), create_modal : false,}));
    }

    const updateFreeAddOnRule = async () => {
        setState(state => ({...state, update_loading : true, }));
        const free_add_on_rule_id = state?.edit_modal;
        const { name, free_add_on_quantity, add_on_setup_id, is_adjustable, min_required_ticket_quantity, max_required_ticket_quantity, free_add_on_rule_requires = [], } = edit_form?.getFieldsValue();

        const updateFreeAddOnRuleResponse = await parkService?.updateFreeAddOnRule(free_add_on_rule_id, {
            name, free_add_on_quantity, add_on_setup_id, is_adjustable, min_required_ticket_quantity, max_required_ticket_quantity, free_add_on_rule_requires,
        });

        notification?.success({
            message : 'Updated Add On Purchase Condition',
        })

        setState(state => ({...state, update_loading : false, refresh : (state?.refresh + 1), edit_modal : null, }));
    }

    const deleteFreeAddOnRule = async (free_add_on_rule_id) => {
        const deleteFreeTicketRuleResponse = await parkService?.deleteFreeAddOnRule(free_add_on_rule_id);
        
        notification?.success({
            message : 'Free Add On Rule Deleted',
        })

        setState(state => ({...state, refresh : (state?.refresh + 1)}));
    }

    const fetchFreeAddOnRules = async () => {
        setState(state => ({...state, loading : true, }));

        const freeAddOnRuleResponse = await parkService?.getFreeAddOnRule({
            park_id : park?.park_id,
        });

        const { free_add_on_rules, } = freeAddOnRuleResponse;

        setState(state => ({...state, loading : false, free_add_on_rules, }));
    }

    useEffect(() => {
        fetchFreeAddOnRules();
    }, [park?.park_id, state?.refresh])

    return (
        <>
            <Card
            styles={{ body : { padding : 12, } }}
            >
                <div style={{ display : 'flex', alignItems : 'center', }}>
                    <div style={{ textAlign : 'start', }}>
                        <div>
                            <span>Add On Purchase Condition</span>
                        </div>
                        <div>
                            <span style={{ fontSize : 12, color : 'var(--secondary-text-color)', }}>Conditions to get or purchase specific add on</span>
                        </div>
                    </div>
                    <div style={{ marginLeft : 'auto', }}>
                        <Button
                        icon={<PlusOutlined />}
                        onClick={() => setState(state => ({...state, create_modal : true, modal : (state?.modal + 1), }))}
                        >
                            Add On Purchase Condition
                        </Button>
                    </div>
                </div>

                <div style={{ marginTop : 12, }}>
                    <Table
                    {...(state?.free_add_on_rules?.length > 0) && ({ scroll : { x : 400, } })}
                    className='hub-table bordered nested-table'
                    size='small'
                    dataSource={state?.free_add_on_rules}
                    pagination={false}
                    columns={[{
                        title : 'Name',
                        dataIndex : 'name',
                        key : 'name',
                    },{
                        title : 'Ticket Type',
                        dataIndex : 'add_on_setup',
                        key : 'add_on_setup',
                        render : (add_on_setup, row, index) => {
                            const { image, name, } = add_on_setup?.park_applicable_ticket_type ?? {};
                            return (
                                <>
                                    <Space>
                                        <div>
                                            <Avatar icon={<AppstoreOutlined />} shape='square' size='small' src={image} />
                                        </div>
                                        <div>
                                            <span>{name}</span>
                                        </div>
                                    </Space>
                                </>
                            )
                        }
                    },{
                        title : 'Add Ons',
                        dataIndex : 'add_on_setup',
                        key : 'add_on_setup',
                        render : (add_on_setup, row, index) => {
                            const { free_add_on_quantity, } = row;
                            const { add_on, } = add_on_setup ?? {};
                            return (
                                <>
                                    <Space>
                                        <div>
                                            <span>{free_add_on_quantity}</span>
                                        </div>
                                        <div>
                                            <span>{add_on?.name}</span>
                                        </div>
                                    </Space>
                                </>
                            )
                        }
                    }, {
                        title : 'Condition',
                        dataIndex : 'free_add_on_rule_requires',
                        key : 'free_add_on_rule_requires',
                        render : (free_add_on_rule_requires, row, index) => {
                            const { min_required_ticket_quantity, max_required_ticket_quantity, } = row;
                            const required_ticket_user_types = (free_add_on_rule_requires?.map(x => x?.ticket_applicable_users?.ticket_user_type));
                            const ticket_user_types = required_ticket_user_types?.map(x => x?.name)?.join(", ");

                            return (
                                <>
                                    <Space>
                                        <div>
                                            <span>Purchase {min_required_ticket_quantity} to {max_required_ticket_quantity} tickets</span>
                                        </div>
                                        <div>
                                            <span>({ticket_user_types})</span>
                                        </div>
                                    </Space>
                                </>
                            )
                        }
                    },{
                        title : 'Action',
                        dataIndex : 'free_add_on_rule_id',
                        key : 'free_add_on_rule_id',
                        fixed : 'right',
                        width : 100,
                        render : (free_add_on_rule_id, row, index) => {
                            return (
                                <>
                                    <Space.Compact>
                                        <Button
                                        size='small'
                                        icon={<EditOutlined style={{color : 'var(--secondary-text-color)'}} />}
                                        onClick={() => setState(state => ({...state, edit_modal : free_add_on_rule_id, modal : (state?.modal + 1), }))}
                                        />
                                        <Popconfirm
                                        onConfirm={() => deleteFreeAddOnRule(free_add_on_rule_id)}
                                        title="Delete Ticket Purchase Condition"
                                        // description={name}
                                        styles={{ root : { width : 250, } }}
                                        // overlayStyle={{ width : 250,}}
                                        >
                                            <Button
                                            size='small'
                                            icon={<DeleteOutlined style={{color : 'var(--secondary-text-color)',}} />}
                                            />
                                        </Popconfirm>
                                    </Space.Compact>
                                </>
                            )
                        }
                    },]}
                    />
                </div>
            </Card>

            <Modal
            title="New Add On Purchase Condition"
            open={state?.create_modal}
            onCancel={() => {
                setState(state => ({...state, create_modal : null, modal : (state?.modal + 1), }));
            }}
            onOk={() => save_form.submit()}
            width={800}
            confirmLoading={state?.save_loading}
            centered
            >
                <Form
                form={save_form}
                layout='vertical'
                onFinish={saveFreeAddOnRule}
                >
                    <AddFreeAddOnRuleModal form={save_form} park={park} modal_visible={state?.modal} />
                </Form>
            </Modal>

            <Modal
            title="Edit Ticket Purchase Condition"
            open={state?.edit_modal}
            onCancel={() => {
                setState(state => ({...state, edit_modal : null, modal : (state?.modal + 1), }));
            }}
            onOk={() => edit_form.submit()}
            width={800}
            confirmLoading={state?.update_loading}
            centered
            >
                <Form
                form={edit_form}
                layout='vertical'
                onFinish={updateFreeAddOnRule}
                >
                    <EditFreeAddOnRuleModal form={edit_form} park={park} modal_visible={state?.modal} free_add_on_rule_id={state?.edit_modal} />
                </Form>
            </Modal>
        </>
    );
}

export default FreeAddOnLayout;